/**
 * Sidebar
 * ======================================
 * - add / remove global class to body
 * - add class to target sidebar element
 */

 const BTNS = '.js-SidebarOpen'
 const CLOSE_BTNS = '.js-SidebarClose'
 const GROUP_BTNS = '.js-SidebarGroup'
 const SIDEBARS = '.js-Sidebar'
 const GLOBAL_CLASS = 'sidebar-is-open'
 const GLOBAL_DISABLE_OVERLAY_CLASS = 'sidebar-overlay-is-disabled'
 const LOCAL_CLASS = 'is-open'

 class Sidebars {
   constructor() {
     this.btns = document.querySelectorAll(BTNS)
     this.close_btns = document.querySelectorAll(CLOSE_BTNS)
     this.group_btns = document.querySelectorAll(GROUP_BTNS)

     if (!this.btns) {
       return false
     }

     this.btns.forEach(el => {
      el.addEventListener('click', this.open, false)
    })

    this.close_btns.forEach(el => {
      el.addEventListener('click', this.close, false)
    })

    this.group_btns.forEach(el => {
      el.addEventListener('click', this.groupMove, false)
    })
   }

   groupMove = (e) => {
    const el = e.currentTarget
    const group = el.closest('.sidebar__group')
    const groupDirection = el.getAttribute('data-group')

    if(groupDirection == 'next') {
      group.classList.add('is-next')
    } else {
      group.classList.remove('is-next')
    }

    e.preventDefault()
  }

   open = (e) => {
    const el = e.currentTarget
    const sidebarSelector = el.getAttribute('data-sidebar')
    const sidebarHref = el.getAttribute('data-href')
    const disableOverlay = el.hasAttribute('data-disable-overlay')
    const targetSidebar = document.querySelector(sidebarSelector)

    targetSidebar.classList.add(LOCAL_CLASS)
    document.body.classList.add(GLOBAL_CLASS)

    if(sidebarHref) {
      window.history.pushState({}, '', sidebarHref);
    }

    if(disableOverlay) {
      document.body.classList.add(GLOBAL_DISABLE_OVERLAY_CLASS)
    }

    e.preventDefault()
  }

  close = (e) => {
    document.querySelectorAll(SIDEBARS).forEach(el => {
      el.classList.remove(LOCAL_CLASS)
    })

    window.history.pushState({}, '', homeUrl);

    document.body.classList.remove(GLOBAL_CLASS)
    document.body.classList.remove(GLOBAL_DISABLE_OVERLAY_CLASS)

    e.preventDefault()
  }
 }

 new Sidebars()
